import Button from '../../../components/base/Button';

interface InvestmentSectionProps {
  onOpenModal?: () => void;
}

export default function InvestmentSection({ onOpenModal }: InvestmentSectionProps) {
  const handleCTAClick = () => {
    if (onOpenModal) {
      onOpenModal();
    }
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Investimento
          </h2>
          <p className="text-lg text-gray-600">
            Uma experiência que pode mudar sua forma de se comunicar.
          </p>
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-2xl p-8 shadow-xl mb-8">
          <div className="text-center mb-8">
            <p className="text-lg text-gray-300 mb-4">Valor de participação:</p>
            
            <div className="mb-8">
              <div className="inline-block bg-[#F19E1A] rounded-lg px-6 py-3 mb-4">
                <p className="text-sm font-semibold uppercase tracking-wide">Parcelado em até</p>
              </div>
              <p className="text-4xl md:text-5xl font-bold mb-2">
                10x de <span className="text-[#F19E1A]">R$ 69,90</span>
              </p>
              <p className="text-gray-400">sem juros no cartão</p>
            </div>

            <div className="border-t border-gray-700 pt-6">
              <p className="text-lg text-gray-300 mb-2">ou à vista com desconto</p>
              <p className="text-2xl font-bold text-[#F19E1A]">
                R$ 629,10
              </p>
              <p className="text-sm text-gray-400 mt-2">
                (10% de desconto)
              </p>
            </div>
          </div>

          <div className="bg-red-500/20 border-2 border-red-500 rounded-lg p-4 flex items-start gap-3">
            <i className="ri-alarm-warning-line text-red-400 text-2xl flex-shrink-0"></i>
            <div>
              <p className="font-bold text-white mb-1">Vagas limitadas</p>
              <p className="text-sm text-gray-300">
                Para manter a qualidade da experiência, limitamos o número de participantes.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-gray-50 rounded-lg p-4 text-center">
            <i className="ri-shield-check-line text-[#F19E1A] text-3xl mb-2 inline-block"></i>
            <p className="text-sm font-semibold text-gray-700">Ambiente Seguro</p>
          </div>
          <div className="bg-gray-50 rounded-lg p-4 text-center">
            <i className="ri-user-star-line text-[#F19E1A] text-3xl mb-2 inline-block"></i>
            <p className="text-sm font-semibold text-gray-700">Instrutores Experientes</p>
          </div>
          <div className="bg-gray-50 rounded-lg p-4 text-center">
            <i className="ri-medal-line text-[#F19E1A] text-3xl mb-2 inline-block"></i>
            <p className="text-sm font-semibold text-gray-700">Metodologia Comprovada</p>
          </div>
        </div>

        <div className="text-center">
          <Button 
            size="lg" 
            onClick={handleCTAClick}
            className="text-lg px-10 py-4 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
          >
            🎯 Quero Garantir Minha Vaga
          </Button>
          <p className="text-sm text-gray-500 mt-4">
            Preencha o formulário e nossa equipe entrará em contato
          </p>
        </div>
      </div>
    </section>
  );
}
